<!--标签管理页面-->
<template>
  <div class="label-manage">
    <gs-modal
      v-model="visible"
      :before-close="beforeClose"
      title="标签管理"
      class="label-manage-modal"
      width="600px"
      top="10%"
      @close="close"
      append-to-body
    >
      <!-- 标签列表区域 -->
      <div class="label-list-container">
        <div class="label-list-content">
          <div class="label-items-container">
            <gs-checkbox-group
              style="width: 100%"
              v-model="selectedTags"
              @change="handleTagSelect"
            >
              <div
                v-for="(tag, index) in tagList"
                :key="tag.id || index"
                class="label-item"
              >
                <div class="label-checkbox">
                  <gs-checkbox :label="tag.id" />
                </div>
                <div
                  class="label-name"
                  :class="{ active: selectedTags.includes(tag.id) }"
                >
                  {{ tag.name }}
                </div>
                <!-- <div class="label-actions">
                <i
                  class="el-icon-view"
                  title="查看标签下绑定的资源"
                  @click="viewTag(tag)"
                ></i>
                <i
                  class="el-icon-edit"
                  title="编辑标签"
                  @click="editTag(tag)"
                ></i>
                <i
                  class="el-icon-delete"
                  title="删除标签"
                  @click="deleteTag(tag)"
                ></i>
              </div> -->
              </div>
            </gs-checkbox-group>
          </div>

          <div class="no-label" v-if="tagList.length === 0">暂无标签</div>
        </div>
      </div>

      <!-- 底部操作按钮 -->
      <div slot="footer" class="dialog-footer">
        <!-- <gs-button
          type="primary"
          size="small"
          @click="showAddDialog"
          class="add-btn"
        >
          新增标签
        </gs-button> -->
        <gs-button type="primary" @click="handleConfirm">确定</gs-button>
      </div>
    </gs-modal>

    <!-- 查看标签绑定资源弹窗 -->
    <gs-modal
      v-model="viewResourceVisible"
      :before-close="beforeCloseViewResource"
      :title="viewResourceTitle"
      class="view-resource-modal"
      width="50%"
      top="15%"
      @close="closeViewResource"
      append-to-body
    >
      <div class="resource-list-container">
        <div v-if="resourceList.length === 0" class="no-resource">
          该标签下暂无绑定资源
        </div>
        <div v-else class="resource-list">
          <div
            v-for="(resource, index) in resourceList"
            :key="resource.id || index"
            class="resource-item"
          >
            {{ resource.resourceFullName }}
          </div>
        </div>
      </div>
    </gs-modal>

    <!-- 新增/编辑标签弹窗 -->
    <gs-modal
      v-model="addEditVisible"
      :before-close="beforeCloseAddEdit"
      :title="isEdit ? '编辑标签' : '新增标签'"
      class="add-edit-modal"
      width="40%"
      top="20%"
      @close="closeAddEdit"
      @confirm="handleConfirmAddEdit"
      append-to-body
    >
      <gs-form
        ref="tagForm"
        :model="tagForm"
        label-width="80px"
        label-position="left"
        gap="small"
      >
        <gs-form-item
          label="名称"
          prop="name"
          class="form-item-radio"
          :rules="[
            { required: true, message: '请输入标签名称', trigger: 'blur' },
          ]"
        >
          <gs-input
            ref="nameInput"
            v-model="tagForm.name"
            placeholder="请输入标签名称"
          />
        </gs-form-item>
      </gs-form>

      <div slot="footer" class="dialog-footer">
        <gs-button @click="beforeCloseAddEdit">取消</gs-button>
        <gs-button type="primary" @click="handleConfirmAddEdit">确认</gs-button>
      </div>
    </gs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import service from "../../service/leftService.js";

export default {
  name: "LabelManage",
  data() {
    return {
      // 标签列表数据
      tagList: [],
      // 选中的标签ID数组
      selectedTags: [],
      // 新增/编辑弹窗显示状态
      addEditVisible: false,
      // 查看资源弹窗显示状态
      viewResourceVisible: false,
      // 查看资源弹窗标题
      viewResourceTitle: "",
      // 资源列表
      resourceList: [],
      // 当前查看的标签
      currentViewTag: null,
      // 是否为编辑模式
      isEdit: false,
      // 当前编辑的标签
      currentTag: null,
      // 要删除的标签
      // 表单数据
      tagForm: {
        name: "",
        description: "",
      },
    };
  },
  computed: {
    ...mapState({
      visible: "labelManageShow", // 需要在state.js中添加这个状态
    }),
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadTagList();
        this.selectedTags = [];
      }
    },
    addEditVisible(newVal) {
      if (newVal && this.$refs.nameInput) {
        setTimeout(() => {
          this.$refs.nameInput.focus();
        }, 100);
      }
    },
  },
  methods: {
    ...mapMutations({
      close: "LABEL_MANAGE_HIDE",
    }),

    // 加载标签列表
    async loadTagList() {
      try {
        const response = await service.findAllPointLabel();
        this.tagList = response || [];
      } catch (error) {
        console.error("加载标签列表失败:", error);
        this.$message.error("加载标签列表失败");
      }
    },

    beforeClose() {
      this.close();
    },

    handleConfirm() {
      if (this.selectedTags.length === 0) {
        this.$message.warning("请选择标签");
        return;
      }

      this.$emit(
        "confirm",
        this.tagList.filter((tag) => this.selectedTags.includes(tag.id))
      );
      this.close();
    },

    // 显示新增弹窗
    showAddDialog() {
      this.isEdit = false;
      this.tagForm = {
        name: "",
      };
      this.addEditVisible = true;
    },

    // 编辑标签
    editTag(tag) {
      this.isEdit = true;
      this.currentTag = tag;
      this.tagForm = {
        name: tag.name,
      };
      this.addEditVisible = true;
    },

    // 查看标签下绑定的资源
    async viewTag(tag) {
      this.currentViewTag = tag;
      this.viewResourceTitle = `${tag.name}标签下绑定的资源`;
      this.viewResourceVisible = true;

      try {
        const response = await service.findLabelBoundResource({
          labelId: tag.id,
        });
        console.log(response);
        this.resourceList = response || [];
      } catch (error) {
        console.error("查询标签绑定资源失败:", error);
        this.$message.error("查询标签绑定资源失败");
        this.resourceList = [];
      }
    },

    // 删除标签
    deleteTag(tag) {
      this.deleteTagList = [tag];
      this.deleteVisible = true;
      this.$confirm("确认删除标签吗?, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.deleteTagList = [tag];

        const ids = this.deleteTagList.map((tag) => tag.id);
        await service.deletePointLabel(ids);
        this.$message.success("标签删除成功");
        this.loadTagList(); // 重新加载标签列表
      });
    },

    // 处理标签选择（使用checkbox实现单选）
    handleTagSelect(selectedValues) {
      // 如果选择了多个，只保留最后一个
      if (selectedValues.length > 1) {
        this.selectedTags = [selectedValues[selectedValues.length - 1]];
      }
      // 可以在这里添加选择标签后的逻辑
    },

    // 关闭查看资源弹窗
    beforeCloseViewResource() {
      this.viewResourceVisible = false;
    },

    closeViewResource() {
      this.viewResourceVisible = false;
    },

    // 关闭新增/编辑弹窗
    beforeCloseAddEdit() {
      this.addEditVisible = false;
    },

    closeAddEdit() {
      this.addEditVisible = false;
    },

    // 确认新增/编辑
    async handleConfirmAddEdit() {
      // 表单验证
      if (!this.tagForm.name.trim()) {
        this.$message.warning("请输入标签名称");
        return;
      }

      try {
        const tagData = {
          name: this.tagForm.name.trim(),
        };

        if (this.isEdit && this.currentTag) {
          // 编辑标签
          tagData.id = this.currentTag.id;
          await service.updatePointLabel(tagData);
          this.$message.success("标签修改成功");
        } else {
          // 新增标签
          await service.savePointLabel(tagData);
          this.$message.success("标签创建成功");
        }

        this.addEditVisible = false;
        this.loadTagList(); // 重新加载标签列表
      } catch (error) {
        console.error("保存标签失败:", error);
        this.$message.error(this.isEdit ? "标签修改失败" : "标签创建失败");
      }
    },
  },
};
</script>

<style scoped lang="scss">
>>> .gs-checkbox-label {
  display: none;
}
.label-manage {
  position: relative;
}

.label-manage-modal {
  z-index: 2000;
}

.label-list-container {
  padding: 20px;
}

.label-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e6e6e6;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.add-btn {
  background-color: #ff9500;
  border-color: #ff9500;
}

.add-btn:hover {
  background-color: #e6850e;
  border-color: #e6850e;
}

.label-list-content {
  max-height: 400px;
  overflow-y: auto;
}

.label-items-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.label-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  color: #fff;
  width: calc(100% / 3 - 10px);
}

.label-checkbox {
  margin-right: 12px;
}

.label-name {
  flex: 1;
  font-size: 14px;
  color: #fff;
  transition: color 0.3s;
}

.label-name.active {
  color: #ff9500;
  font-weight: bold;
}

.label-actions {
  display: flex;
  gap: 8px;
}
.label-actions i {
  cursor: pointer;
}

.label-actions .gs-button {
  padding: 4px 8px;
  font-size: 12px;
}

.delete-btn {
  color: #ff4d4f;
}

.delete-btn:hover {
  color: #ff7875;
}

.dialog-footer {
  text-align: right;
  padding: 10px 0;
}

.dialog-footer .gs-button {
  margin-left: 10px;
}

.view-resource-modal {
  z-index: 2001;
}

.add-edit-modal {
  z-index: 2002;
}

.delete-content {
  text-align: center;
  padding: 20px 0;
}

.delete-content p {
  margin: 10px 0;
  color: #666;
}

.delete-tip {
  font-size: 12px;
  color: #999;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .label-manage-modal {
    width: 90% !important;
  }

  .add-edit-modal {
    width: 80% !important;
  }

  .delete-modal {
    width: 70% !important;
  }
}

/* 滚动条样式 */
.label-list-content::-webkit-scrollbar {
  width: 6px;
}

.label-list-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.label-list-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.label-list-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.no-label {
  text-align: center;
  padding: 20px 0;
  color: #999;
}

.resource-list-container {
  padding: 10px 0;
}

.resource-list {
  max-height: 300px;
  overflow-y: auto;
}

.resource-item {
  padding: 12px 16px;
  margin-bottom: 8px;
  background-color: #666;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-all;
}

.no-resource {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}
/deep/ .gs-checkbox-group {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
/* 隐藏checkbox的标签文字 */
</style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/statisticModule/labelManage.vue